import { request } from '../http/request'
import { API_BASE_URL } from './config'

export const TICKET_OFFER_STATUSES = [
  { value: 'draft', title: 'Rascunho' },
  { value: 'ready_for_site', title: 'Pronto p/ site' },
  { value: 'published', title: 'Enviado ao site' },
  { value: 'paused', title: 'Pausado' },
]

class TicketOfferService {
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/ticketOffer/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }

  get(id) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/ticketOffer/${id}`, 'get')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }

  updateOrCreate(data) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/ticketOffer/updateOrCreate`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }

  push(id) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/ticketOffer/${id}/push`, 'post')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }

  setStatus(id, site_status) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/ticketOffer/${id}/status`, 'post', { site_status })
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }

  delete(id) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/ticketOffer/${id}`, 'delete')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
}

export const ticketOffer = new TicketOfferService()
